import { render } from "./CachedDomains.vue?vue&type=template&id=6d2c08bf&scoped=true"
import script from "./CachedDomains.vue?vue&type=script&lang=js"
export * from "./CachedDomains.vue?vue&type=script&lang=js"

import "./CachedDomains.vue?vue&type=style&index=0&id=6d2c08bf&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2c08bf"]])

export default __exports__